import { Navigate, Route, Routes } from 'react-router';
import { Trans } from '@lingui/react/macro';

import { SettingsSectionLayout } from '../../../components/Layout/Layout';

import { BrandsRoutes } from './subsections/Brands/Brands';
import { ProductAttributes } from './subsections/ProductAttributes/ProductAttributes';
import { ProductsRoutes } from './subsections/Products/Products';

export const DataCatalogs = () => {
  return (
    <SettingsSectionLayout
      title={<Trans id="settings-section.catalog">Catalog</Trans>}
      tabs={[
        {
          id: 'brands',
          label: <Trans id="settings.organization.data-catalogs.brands">Brands</Trans>,
        },
        {
          id: 'product-attributes',
          label: (
            <Trans id="settings.organization.data-catalogs.product-attributes">
              Product attributes
            </Trans>
          ),
        },
        {
          id: 'products',
          label: <Trans id="settings.organization.data-catalogs.products">Products</Trans>,
        },
      ]}
    >
      <Routes>
        <Route path="" element={<Navigate to="/settings_beta/catalog/brands" replace />} />
        <Route path="brands/*" element={<BrandsRoutes />} />
        <Route path="products/*" element={<ProductsRoutes />} />
        <Route path="product-attributes" element={<ProductAttributes />} />
        <Route path="*" element={<Navigate to="/settings_beta/catalog/brands" replace />} />
      </Routes>
    </SettingsSectionLayout>
  );
};
